// extracted by mini-css-extract-plugin
module.exports =  {"close":"_2787e5dfdf--close--L56WD","content":"_2787e5dfdf--content--u85Pr","img":"_2787e5dfdf--img--bGQlE","link":"_2787e5dfdf--link--gU5MI"};